import moment from 'moment'

export function returnValueOrZero(val) {
    return (!val || "0" === val || "" === val || " " === val) ? 0 : val;
}

export function prepTransactions(transactions, offsetKeyDate) {
    if ([].constructor !== transactions.constructor || !transactions.length) {
        return { aggregateByDate: {}, aggregation: [], sum: { Revenue: 0, Investment: 0 }, status: 'empty' }
    }

    let aggregateByDate = transactions.reduce((aggregateByDate, transaction) => {
        let day = moment(transaction.pub_date).format('L') // .date(), .month() and .year()

        let invest = 0;
        if (transaction.hasOwnProperty('cashback_value')) {
            invest = transaction.cashback_value
        } else if (transaction.hasOwnProperty('refund')) {
            invest = transaction.refund
        }

        aggregateByDate[day] = {
            Revenue: aggregateByDate[day] && aggregateByDate[day].Revenue
                        ? aggregateByDate[day].Revenue + parseFloat(returnValueOrZero(transaction.transaction_value))
                        : parseFloat(returnValueOrZero(transaction.transaction_value)),
            Investment: aggregateByDate[day] && aggregateByDate[day].Investment
                        ? aggregateByDate[day].Investment + parseFloat(returnValueOrZero(transaction.fee)) + parseFloat(returnValueOrZero(invest))
                        : parseFloat(returnValueOrZero(transaction.fee)) + parseFloat(returnValueOrZero(invest))
        }

        return aggregateByDate
    }, {})

    // Only aggregate data for visible dates
    // let aggregation = Object.keys(aggregateByDate).map((day) => {
    //     return {
    //         pub_date: day,
    //         transaction_value: aggregateByDate[day]
    //     }
    // })

    // aggreate for all the days in a given period
    let rev = [], invest = [], sumRevenue = 0, sumInvest = 0

    const firstLoop = moment.utc(offsetKeyDate.start)
    const lastLoop = moment.utc(offsetKeyDate.end)

    for (let d=firstLoop; d.isSameOrBefore(lastLoop, 'day'); d.add(1, 'day')) {
        let val = { Revenue: 0, Investment: 0 }
        let day = d.format('L')

        if ('undefined' !== typeof aggregateByDate[day]) {
            val = aggregateByDate[day]

            sumRevenue += parseFloat(val.Revenue)
            sumInvest += parseFloat(val.Investment)
        }

        rev.push({
            x: day,
            y: parseFloat(val.Revenue)
        })

        invest.push({
            x: day,
            y: parseFloat(val.Investment)
        })
    }

    return {
        aggregateByDate,
        aggregation: {
            Revenue: rev,
            Investment: invest
        },
        sum : {
            Revenue: sumRevenue,
            Investment: sumInvest
        }
    }
}

export function prepWeeklyReport(transactions) {
    if ([].constructor !== transactions.constructor || !transactions.length) {
        return { aggregation: {}, customers: 0 }
    }

    let aggregation = transactions.reduce((aggregation, transaction) => {
        let cashback = 0;
        if (transaction.hasOwnProperty('cashback_value')) {
            cashback = parseFloat(returnValueOrZero(transaction.cashback_value))
        } else if (transaction.hasOwnProperty('refund')) {
            cashback = parseFloat(returnValueOrZero(transaction.refund))
        }

        let marketing = parseFloat(returnValueOrZero(transaction.fee))

        aggregation = {
            revenue: aggregation && aggregation.revenue
                        ? aggregation.revenue + parseFloat(returnValueOrZero(transaction.transaction_value))
                        : parseFloat(returnValueOrZero(transaction.transaction_value)),
            cashback: aggregation && aggregation.cashback
                        ? aggregation.cashback + cashback
                        : cashback,
            marketing: aggregation && aggregation.marketing
                        ? aggregation.marketing + marketing
                        : marketing,
            total: aggregation && aggregation.total
                        ? aggregation.total + cashback + marketing
                        : cashback + marketing
        }

        return aggregation
    }, {})

    return {
        aggregation,
        customers: transactions.length
    }
}



// WEBPACK FOOTER //
// ./src/lib/dataTools.js